export const letterC = {
  nouns: [
    {"boss": ["Chef", "Chefs", "der", "die", "m"]},
    {"café": ["Café", "Cafés", "das", "die", "n"]},
    {"computer": ["Computer", "Computer", "der", "die", "m"]},
    {"CD": ["CD", "CDs", "die", "die", "f"]}
  ],
  verbs: [
    {"to chat": ["chatten", "chatte", "chattest", "chattet", "chattet", "chattet", "chatten", "chattet", "chatten", "chatten"]},
    {"to come": ["kommen", "komme", "kommst", "kommt", "kommt", "kommt", "kommen", "kommt", "kommen", "kommen"]},
    {"to buy": ["kaufen", "kaufe", "kaufst", "kauft", "kauft", "kauft", "kaufen", "kauft", "kaufen", "kaufen"]},
    {"to can": ["können", "kann", "kannst", "kann", "kann", "kann", "können", "könnt", "können", "können"]},
    {"to cook": ["kochen", "koche", "kochst", "kocht", "kocht", "kocht", "kochen", "kocht", "kochen", "kochen"]},
    {"to cost": ["kosten", "koste", "kostest", "kostet", "kostet", "kostet", "kosten", "kostet", "kosten", "kosten"]},
    {"to get": ["kriegen", "kriege", "kriegst", "kriegt", "kriegt", "kriegt", "kriegen", "kriegt", "kriegen", "kriegen"]},
    {"to care for": ["kümmern", "kümmere", "kümmerst", "kümmert", "kümmert", "kümmert", "kümmern", "kümmert", "kümmern", "kümmern"]},
    {"to know": ["kennen", "kenne", "kennst", "kennt", "kennt", "kennt", "kennen", "kennt", "kennen", "kennen"]},
    {"to learn": ["lernen", "lerne", "lernst", "lernt", "lernt", "lernt", "lernen", "lernt", "lernen", "lernen"]},
    {"to read": ["lesen", "lese", "liest", "liest", "liest", "liest", "lesen", "lest", "lesen", "lesen"]},
    {"to lie": ["liegen", "liege", "liegst", "liegt", "liegt", "liegt", "liegen", "liegt", "liegen", "liegen"]},
    {"to love": ["lieben", "liebe", "liebst", "liebt", "liebt", "liebt", "lieben", "liebt", "lieben", "lieben"]},
    {"to laugh": ["lachen", "lache", "lachst", "lacht", "lacht", "lacht", "lachen", "lacht", "lachen", "lachen"]},
    {"to run": ["laufen", "laufe", "läufst", "läuft", "läuft", "läuft", "laufen", "lauft", "laufen", "laufen"]},
    {"to live": ["leben", "lebe", "lebst", "lebt", "lebt", "lebt", "leben", "lebt", "leben", "leben"]},
    {"to lay": ["legen", "lege", "legst", "legt", "legt", "legt", "legen", "legt", "legen", "legen"]},
    {"to have": ["haben", "habe", "hast", "hat", "hat", "hat", "haben", "habt", "haben", "haben"]},
    {"to be": ["sein", "bin", "bist", "ist", "ist", "ist", "sind", "seid", "sind", "sind"]},
    {"to go": ["gehen", "gehe", "gehst", "geht", "geht", "geht", "gehen", "geht", "gehen", "gehen"]},
    {"to see": ["sehen", "sehe", "siehst", "sieht", "sieht", "sieht", "sehen", "seht", "sehen", "sehen"]},
    {"to give": ["geben", "gebe", "gibst", "gibt", "gibt", "gibt", "geben", "gebt", "geben", "geben"]},
    {"to do": ["machen", "mache", "machst", "macht", "macht", "macht", "machen", "macht", "machen", "machen"]}
  ],
  examples: {
    nominative: [
      {
        german: '___ Chef ist hier.',
        english: 'The boss is here.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Café ist neu.',
        english: 'The café is new.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Computer funktioniert.',
        english: 'The computer works.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ CD ist neu.',
        english: 'The CD is new.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Chef kommt.',
        english: 'The boss is coming.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Café hat WLAN.',
        english: 'The café has WiFi.',
        answer: 'Das',
        case: 'nominative'
      },
      {
        german: '___ Computer ist schnell.',
        english: 'The computer is fast.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ CD spielt.',
        english: 'The CD is playing.',
        answer: 'Die',
        case: 'nominative'
      },
      {
        german: '___ Chef arbeitet.',
        english: 'The boss is working.',
        answer: 'Der',
        case: 'nominative'
      },
      {
        german: '___ Café ist voll.',
        english: 'The café is full.',
        answer: 'Das',
        case: 'nominative'
      }
    ],
    accusative: [
      {
        german: 'Ich sehe ___ Chef.',
        english: 'I see the boss.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Er braucht ___ Computer.',
        english: 'He needs the computer.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Sie besucht ___ Café.',
        english: 'She visits the café.',
        answer: 'das',
        case: 'accusative'
      },
      {
        german: 'Wir haben ___ CD.',
        english: 'We have the CD.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Du kaufst ___ Computer.',
        english: 'You buy the computer.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Ich lerne ___ CD.',
        english: 'I learn the CD.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Sie liest ___ CD.',
        english: 'She reads the CD.',
        answer: 'die',
        case: 'accusative'
      },
      {
        german: 'Er kostet ___ Computer.',
        english: 'The computer costs.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Wir kennen ___ Chef.',
        english: 'We know the boss.',
        answer: 'den',
        case: 'accusative'
      },
      {
        german: 'Du kaufst ___ CD.',
        english: 'You buy the CD.',
        answer: 'die',
        case: 'accusative'
      }
    ],
    dative: [
      {
        german: 'Ich helfe ___ Chef.',
        english: 'I help the boss.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Sie gibt ___ Kind ___ Computer.',
        english: 'She gives the child the computer.',
        answer: 'dem den',
        case: 'dative'
      },
      {
        german: 'Er spricht mit ___ Chef.',
        english: 'He speaks with the boss.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Wir danken ___ CD.',
        english: 'We thank for the CD.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Du gehst zu ___ Café.',
        english: 'You go to the café.',
        answer: 'dem',
        case: 'dative'
      },
      {
        german: 'Ich gebe ___ Chef ___ CD.',
        english: 'I give the boss the CD.',
        answer: 'dem die',
        case: 'dative'
      },
      {
        german: 'Sie arbeitet für ___ Chef.',
        english: 'She works for the boss.',
        answer: 'den',
        case: 'dative'
      },
      {
        german: 'Er kocht für ___ Computer.',
        english: 'He cooks for the computer.',
        answer: 'den',
        case: 'dative'
      },
      {
        german: 'Wir lernen von ___ CD.',
        english: 'We learn from the CD.',
        answer: 'der',
        case: 'dative'
      },
      {
        german: 'Du sprichst mit ___ Chef.',
        english: 'You speak with the boss.',
        answer: 'dem',
        case: 'dative'
      }
    ],
    translations: [
      {
        english: 'The boss is here.',
        german: 'Der Chef ist hier.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'The café is new.',
        german: 'Das Café ist neu.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'I see the boss.',
        german: 'Ich sehe den Chef.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'She gives the child the computer.',
        german: 'Sie gibt dem Kind den Computer.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'We need a computer.',
        german: 'Wir brauchen einen Computer.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The computer is fast.',
        german: 'Der Computer ist schnell.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'She visits the café.',
        german: 'Sie besucht das Café.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'I know the boss.',
        german: 'Ich kenne den Chef.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'They learn from the CD.',
        german: 'Sie lernen von der CD.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'You go to the café.',
        german: 'Du gehst zum Café.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The CD is new.',
        german: 'Die CD ist neu.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'He works for the boss.',
        german: 'Er arbeitet für den Chef.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'We can use the computer.',
        german: 'Wir können den Computer benutzen.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'She likes the café.',
        german: 'Sie mag das Café.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The boss comes.',
        german: 'Der Chef kommt.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'I cook with the computer.',
        german: 'Ich koche mit dem Computer.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'They read the CD.',
        german: 'Sie lesen die CD.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'You thank the boss.',
        german: 'Du dankst dem Chef.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'The computer costs much.',
        german: 'Der Computer kostet viel.',
        type: 'translation',
        caseType: 'nominative'
      },
      {
        english: 'We chat on the computer.',
        german: 'Wir chatten auf dem Computer.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'She lives near the café.',
        german: 'Sie wohnt beim Café.',
        type: 'translation',
        caseType: 'dative'
      },
      {
        english: 'I love the CD.',
        german: 'Ich liebe die CD.',
        type: 'translation',
        caseType: 'accusative'
      },
      {
        english: 'The boss laughs.',
        german: 'Der Chef lacht.',
        type: 'translation',
        caseType: 'nominative'
      }
    ],
    conjugations: [
      {
        question: 'How do you conjugate "to come" for "I"?',
        answer: 'komme',
        verb: 'kommen',
        verbEnglish: 'to come',
        subject: 'ich',
        conjugation: 'komme'
      },
      {
        question: 'How do you conjugate "to come" for "you" (informal)?',
        answer: 'kommst',
        verb: 'kommen',
        verbEnglish: 'to come',
        subject: 'du',
        conjugation: 'kommst'
      },
      {
        question: 'How do you conjugate "to buy" for "he"?',
        answer: 'kauft',
        verb: 'kaufen',
        verbEnglish: 'to buy',
        subject: 'er',
        conjugation: 'kauft'
      },
      {
        question: 'How do you conjugate "to buy" for "we"?',
        answer: 'kaufen',
        verb: 'kaufen',
        verbEnglish: 'to buy',
        subject: 'wir',
        conjugation: 'kaufen'
      },
      {
        question: 'How do you conjugate "to come" for "they" (formal)?',
        answer: 'kommen',
        verb: 'kommen',
        verbEnglish: 'to come',
        subject: 'Sie',
        conjugation: 'kommen'
      },
      {
        question: 'How do you conjugate "to chat" for "I"?',
        answer: 'chatte',
        verb: 'chatten',
        verbEnglish: 'to chat',
        subject: 'ich',
        conjugation: 'chatte'
      },
      {
        question: 'How do you conjugate "to cook" for "she"?',
        answer: 'kocht',
        verb: 'kochen',
        verbEnglish: 'to cook',
        subject: 'sie',
        conjugation: 'kocht'
      },
      {
        question: 'How do you conjugate "to cost" for "it"?',
        answer: 'kostet',
        verb: 'kosten',
        verbEnglish: 'to cost',
        subject: 'es',
        conjugation: 'kostet'
      },
      {
        question: 'How do you conjugate "to know" for "I"?',
        answer: 'kenne',
        verb: 'kennen',
        verbEnglish: 'to know',
        subject: 'ich',
        conjugation: 'kenne'
      },
      {
        question: 'How do you conjugate "to learn" for "we"?',
        answer: 'lernen',
        verb: 'lernen',
        verbEnglish: 'to learn',
        subject: 'wir',
        conjugation: 'lernen'
      },
      {
        question: 'What is the simple past of "to come" for "I"?',
        answer: 'kam',
        verb: 'kommen',
        verbEnglish: 'to come',
        subject: 'ich',
        conjugation: 'kam'
      },
      {
        question: 'What is the simple past of "to buy" for "she"?',
        answer: 'kaufte',
        verb: 'kaufen',
        verbEnglish: 'to buy',
        subject: 'sie',
        conjugation: 'kaufte'
      },
      {
        question: 'What is the simple past of "to cook" for "he"?',
        answer: 'kochte',
        verb: 'kochen',
        verbEnglish: 'to cook',
        subject: 'er',
        conjugation: 'kochte'
      },
      {
        question: 'What is the simple past of "to cost" for "it"?',
        answer: 'kostete',
        verb: 'kosten',
        verbEnglish: 'to cost',
        subject: 'es',
        conjugation: 'kostete'
      },
      {
        question: 'What is the simple past of "to know" for "we"?',
        answer: 'kannten',
        verb: 'kennen',
        verbEnglish: 'to know',
        subject: 'wir',
        conjugation: 'kannten'
      },
      {
        question: 'What is the simple past of "to learn" for "they"?',
        answer: 'lernten',
        verb: 'lernen',
        verbEnglish: 'to learn',
        subject: 'sie',
        conjugation: 'lernten'
      }
    ]
  }
}
